import './interceptors/axios-interceptor';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import './assets/css/app.css';
import reportWebVitals from './reportWebVitals';
import store from './store/store';
import './assets/css/all.min.css';
import { DrawerProvider } from './components/drawer/DrawerProvider'; // <-- import DrawerProvider

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <DrawerProvider> {/* <-- Add this */}
                <App />
                <ToastContainer
                    position="top-right"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                {/* Same as */}
                <ToastContainer />
            </DrawerProvider> {/* <-- Close it */}
        </Provider>
    </React.StrictMode>
);

reportWebVitals();
